



































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import publishObjectPath from '@/util/configRegistry';
import { hiddenDangerLibraryServer, performanceServer, siteManagementServer } from '@/api/installServer';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class WorkOrderDetailsDialog extends Vue {
  visible: any = false;
  row: any = {};
  loading: any = false;

  // 表单数据
  formData: any = {};

  formRules: any = {};
  imgPath: any = publishObjectPath.imgPathWater;
  dataType: any = [
    {
      name: '基本信息',
    },
    {
      name: '整改信息',
    },
    {
      name: '操作日志',
    },
  ];
  tabValue: any = '基本信息';

  showDialog(row: any) {
    this.loading = true;
    this.row = row;
    this.visible = true;

    this.getDetailByIdData();
  }

  created() {
    // this.getHiddenFormNum();
    // this.getCheckDetail();
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getDetailByIdData() {
    // 发起接口请求，获取分页数据
    hiddenDangerLibraryServer
      .getHazardManageDetail(this.row.id)
      .then((res: any) => {
        this.loading = false;
        this.formData = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 点击取消按钮
   */
  close() {
    this.formData = {};
    this.$emit('on-response');
  }

  getLevel(data: any) {
    if (data === 'A') {
      return '重大隐患(A)';
    }
    if (data === 'B') {
      return '一般隐患I级(B)';
    }
    if (data === 'C') {
      return '一般隐患II级(C)';
    }
    if (data === 'D') {
      return '一般隐患III级(D)';
    }
  }
}
